export const options = [
    {
        value: '试剂',
        label: '试剂',
        children: [
            {
                value: '甲状腺功能检验项目',
                label: '甲状腺功能检验项目',
                children: [
                    {value: 'TSH', label: '促甲状腺激素（TSH）'},
                    {value: 'TT3', label: '总三碘甲状腺原氨酸（TT3）'},
                    {value: 'TT4', label: '总甲状腺素（TT4）'},
                    {value: 'FT3', label: '游离三碘甲状腺原氨酸（FT3）'},
                    {value: 'FT4', label: '游离甲状腺素（FT4）'},
                    {value: 'TPOAb', label: '抗甲状腺过氧化物酶抗体（TPOAb）'},
                    {value: 'TGAb', label: '抗甲状腺球蛋白抗体（TGAb）'},
                    {value: 'TRAb', label: '促甲状腺激素受体抗体（TRAb）'},
                    {value: 'Tg', label: '甲状腺球蛋白（Tg）'}
                ]
            },
            {
                value: '心脏功能检验项目',
                label: '心脏功能检验项目',
                children: [
                    {value: 'cTnI', label: '肌钙蛋白I（cTnI）'},
                    {value: 'cTnT', label: '肌钙蛋白T（cTnT）'},
                    {value: 'Hs-cTnI', label: '高敏肌钙蛋白I（Hs-cTnI）'},
                    {value: 'Hs-cTnT', label: '高敏肌钙蛋白T（Hs-cTnT）'},
                    {value: 'CK', label: '肌酸激酶（CK）'},
                    {value: 'CK-MB', label: '肌酸激酶同工酶（CK-MB）'},
                    {value: 'LDH', label: '乳酸脱氢酶（LDH）'},
                    {value: 'BNP', label: 'B型利钠肽（BNP）'},
                    {value: 'NT-proBNP', label: 'N末端B型利钠肽前体（NT-proBNP）'},
                    {value: 'myoglobin/MYO', label: '肌红蛋白（MYO）'},
                    {value: 'HCY', label: '同型半胱氨酸（HCY）'}
                ]
            },
            {
                value: '性激素检验项目',
                label: '性激素检验项目',
                children: [
                    {value: 'FSH', label: '卵泡刺激素（FSH）'},
                    {value: 'LH', label: '黄体生成素（LH）'},
                    {value: 'PRL', label: '催乳素（PRL）'},
                    {value: 'E2', label: '雌二醇（E2）'},
                    {value: 'P', label: '孕酮（P）'},
                    {value: 'T', label: '睾酮（T）'},
                    {value: 'AMH', label: '抗缪勒氏管激素（AMH）'},
                    {value: 'HCG', label: '人绒毛膜促性腺激素（HCG）'},
                    {value: 'SHBG', label: '性激素结合球蛋白（SHBG）'},
                    {value: 'PAPP-A', label: '妊娠相关的血浆蛋白A（PAPP-A）'}
                ]
            },
            {
                value: '肿瘤相关检验项目',
                label: '肿瘤相关检验项目',
                children: [
                    {value: 'CEA', label: '癌胚抗原（CEA）'},
                    {value: 'CA125', label: '糖类抗原 125（CA125）'},
                    {value: 'CA19-9', label: '糖类抗原 19-9（CA19-9）'},
                    {value: 'CA15-3', label: '糖类抗原 15-3（CA15-3）'},
                    {value: 'SCC', label: '鳞状上皮细胞癌抗原（SCC）'},
                    {value: 'NSE', label: '神经元特异性烯醇化酶（NSE）'},
                    {value: 'Pro-GRP', label: '胃泌素前体释放肽片段（Pro-GRP）'},
                    {value: 'CYFRA21-1', label: '细胞角蛋白 19 的片段（CYFRA21-1）'},
                    {value: 'PSA', label: '前列腺特异性抗原（PSA）'},
                    {value: 'fPSA', label: '游离前列腺特异性抗原（fPSA）'},
                    {value: 'p2PSA', label: '前列腺特异性抗原同源异构体（p2PSA）'},
                    {value: 'AFP', label: '甲胎蛋白（AFP）'},
                    {value: 'CA50', label: '糖类抗原 50（CA50）'},
                    {value: 'CA72-4', label: '糖类抗原 72-4（CA72-4）'},
                    {value: 'CA242', label: '糖类抗原 242（CA242）'},
                    {value: 'PGI', label: '胃蛋白酶原I（PGI）'},
                    {value: 'PGII', label: '胃蛋白酶原II（PGII）'},
                    {value: 'G-17', label: '胃泌素17（G-17）'}
                ]
            }
        ]
    },
    {
        value: '疾病',
        label: '疾病',
        children: [
            {
                value: '甲状腺功能检验项目',
                label: '甲状腺功能检验项目',
                children: [
                    {value: 'jiajiang', label: '甲状腺功能亢进症（甲亢）'},
                    {value: 'jiajian', label: '甲状腺功能减退症（甲减）'},
                    {value: 'graves', label: 'Graves病'},
                    {value: 'qiaoben', label: '桥本氏病（慢性淋巴细胞性甲状腺炎）'},
                    {value: 'jiexie', label: '甲状腺结节'},
                    {value: 'xianliu', label: '甲状腺腺瘤'},
                    {value: 'ai', label: '甲状腺癌'},
                    {value: 'yaxing', label: '亚急性甲状腺炎'},
                    {value: 'jixing', label: '急性化脓性甲状腺炎'},
                    {value: 'feizheng', label: '慢性非自身免疫性甲状腺炎'},
                    {value: 'xianian', label: '先天性甲状腺功能减退症（克汀病）'},
                    {value: 'fazhan', label: '甲状腺发育不全'},
                    {value: 'zhongda', label: '甲状腺肿大（甲状腺肿）'},
                    {value: 'zhengchang', label: '甲状腺功能正常性甲状腺肿大'}
                ]
            },
            {
                value: '心脏功能检验项目',
                label: '心脏功能检验项目',
                children: [
                    {value: 'dongguo', label: '窦性心动过速'},
                    {value: 'dongman', label: '窦性心动过缓'},
                    {value: 'fangzao', label: '房性早搏'},
                    {value: 'shizao', label: '室性早搏'},
                    {value: 'fangchan', label: '房颤'},
                    {value: 'shichan', label: '室颤'},
                    {value: 'fangpu', label: '心房扑动'},
                    {value: 'shipu', label: '心室扑动'},
                    {value: 'chuanduan', label: '房室传导阻滞'},
                    {value: 'xinjiaotong', label: '稳定型心绞痛'},
                    {value: 'xinjiaotong', label: '不稳定型心绞痛'},
                    {value: 'xinji', label: '急性心肌梗死'},
                    {value: 'feihuai', label: '肥厚型心肌病'},
                    {value: 'xianzhi', label: '限制型心肌病'},
                    {value: 'shixing', label: '致心律失常性右室心肌病'},
                    {value: 'erjian', label: '二尖瓣狭窄'},
                    {value: 'erbian', label: '二尖瓣关闭不全'},
                    {value: 'zhuji', label: '主动脉瓣狭窄'},
                    {value: 'zhuji', label: '主动脉瓣关闭不全'},
                    {value: 'sanji', label: '三尖瓣狭窄和关闭不全'},
                    {value: 'fei', label: '肺动脉瓣狭窄和关闭不全'},
                    {value: 'xinbao', label: '心包炎'},
                    {value: 'xinbao', label: '心包积液'},
                    {value: 'xinbao', label: '缩窄性心包炎'},
                    {value: 'fangjian', label: '房间隔缺损'},
                    {value: 'shijian', label: '室间隔缺损'},
                    {value: 'daoguan', label: '动脉导管未闭'},
                    {value: 'faluo', label: '法洛四联症'},
                    {value: 'zhuji', label: '主动脉缩窄'},
                    {value: 'xinshuai', label: '左心衰竭'},
                    {value: 'xinshuai', label: '右心衰竭'},
                    {value: 'xinshuai', label: '全心衰竭'},
                    {value: 'xinshock', label: '心源性休克'},
                    {value: 'xinji', label: '心肌炎'},
                    {value: 'xinji', label: '心肌病'},
                    {value: 'xinzhai', label: '心脏肿瘤'}
                ]
            },
            {
                value: '性激素检验项目',
                label: '性激素检验项目',
                children: [
                    {value: 'xinzao', label: '性早熟'},
                    {value: 'chunqi', label: '青春期延迟'},
                    {value: 'xinyou', label: '性幼稚症'},
                    {value: 'nangshen', label: '卵巢功能衰竭'},
                    {value: 'duochuang', label: '多囊卵巢综合征（PCOS）'},
                    {value: 'gao', label: '睾丸功能减退'},
                    {value: 'gao', label: '高泌乳素血症'},
                    {value: 'di', label: '低促性腺激素血症'},
                    {value: 'buyu', label: '不孕不育'},
                    {value: 'yue', label: '月经失调'},
                    {value: 'xian', label: '先天性性分化异常'},
                    {value: 'xian', label: '性激素相关肿瘤'}
                ]
            },
            {
                value: '肿瘤相关检验项目',
                label: '肿瘤相关检验项目',
                children: [
                    {value: '肝癌', label: '肝癌'},
                    {value: 'pancreas', label: '胰腺癌'},
                    {value: 'wei', label: '胃癌'},
                    {value: 'dan', label: '胆囊癌'},
                    {value: 'jiechang', label: '结直肠癌'},
                    {value: 'ru', label: '乳腺癌'},
                    {value: 'fei', label: '肺癌'},
                    {value: 'nang', label: '卵巢癌'},
                    {value: 'nei', label: '子宫内膜癌'},
                    {value: 'qianlie', label: '前列腺癌'},
                    {value: 'pangguang', label: '膀胱癌'},
                    {value: 'shen', label: '肾癌'},
                    {value: 'shi', label: '食管癌'},
                    {value: 'gongjing', label: '宫颈癌'},
                    {value: 'gao', label: '睾丸癌'},
                    {value: 'biyan', label: '鼻咽癌'}
                ]
            }
        ]
    },
]

export const illnessList = [
    {
        value: 'jiajian',
        label: '甲状腺功能检验项目',
        children: [
            {value: 'jiajiang', label: '甲状腺功能亢进症（甲亢）'},
            {value: 'jiajian', label: '甲状腺功能减退症（甲减）'},
            {value: 'graves', label: 'Graves病'},
            {value: 'qiaoben', label: '桥本氏病（慢性淋巴细胞性甲状腺炎）'},
            {value: 'jiexie', label: '甲状腺结节'},
            {value: 'xianliu', label: '甲状腺腺瘤'},
            {value: 'ai', label: '甲状腺癌'},
            {value: 'yaxing', label: '亚急性甲状腺炎'},
            {value: 'jixing', label: '急性化脓性甲状腺炎'},
            {value: 'feizheng', label: '慢性非自身免疫性甲状腺炎'},
            {value: 'xianian', label: '先天性甲状腺功能减退症（克汀病）'},
            {value: 'fazhan', label: '甲状腺发育不全'},
            {value: 'zhongda', label: '甲状腺肿大（甲状腺肿）'},
            {value: 'zhengchang', label: '甲状腺功能正常性甲状腺肿大'}
        ]
    },
    {
        value: 'xinji',
        label: '心脏功能检验项目',
        children: [
            {value: 'dongguo', label: '窦性心动过速'},
            {value: 'dongman', label: '窦性心动过缓'},
            {value: 'fangzao', label: '房性早搏'},
            {value: 'shizao', label: '室性早搏'},
            {value: 'fangchan', label: '房颤'},
            {value: 'shichan', label: '室颤'},
            {value: 'fangpu', label: '心房扑动'},
            {value: 'shipu', label: '心室扑动'},
            {value: 'chuanduan', label: '房室传导阻滞'},
            {value: 'xinjiaotong', label: '稳定型心绞痛'},
            {value: 'xinjiaotong', label: '不稳定型心绞痛'},
            {value: 'xinji', label: '急性心肌梗死'},
            {value: 'feihuai', label: '肥厚型心肌病'},
            {value: 'xianzhi', label: '限制型心肌病'},
            {value: 'shixing', label: '致心律失常性右室心肌病'},
            {value: 'erjian', label: '二尖瓣狭窄'},
            {value: 'erbian', label: '二尖瓣关闭不全'},
            {value: 'zhuji', label: '主动脉瓣狭窄'},
            {value: 'zhuji', label: '主动脉瓣关闭不全'},
            {value: 'sanji', label: '三尖瓣狭窄和关闭不全'},
            {value: 'fei', label: '肺动脉瓣狭窄和关闭不全'},
            {value: 'xinbao', label: '心包炎'},
            {value: 'xinbao', label: '心包积液'},
            {value: 'xinbao', label: '缩窄性心包炎'},
            {value: 'fangjian', label: '房间隔缺损'},
            {value: 'shijian', label: '室间隔缺损'},
            {value: 'daoguan', label: '动脉导管未闭'},
            {value: 'faluo', label: '法洛四联症'},
            {value: 'zhuji', label: '主动脉缩窄'},
            {value: 'xinshuai', label: '左心衰竭'},
            {value: 'xinshuai', label: '右心衰竭'},
            {value: 'xinshuai', label: '全心衰竭'},
            {value: 'xinshock', label: '心源性休克'},
            {value: 'xinji', label: '心肌炎'},
            {value: 'xinji', label: '心肌病'},
            {value: 'xinzhai', label: '心脏肿瘤'}
        ]
    },
    {
        value: 'xinghormone',
        label: '性激素检验项目',
        children: [
            {value: 'xinzao', label: '性早熟'},
            {value: 'chunqi', label: '青春期延迟'},
            {value: 'xinyou', label: '性幼稚症'},
            {value: 'nangshen', label: '卵巢功能衰竭'},
            {value: 'duochuang', label: '多囊卵巢综合征（PCOS）'},
            {value: 'gao', label: '睾丸功能减退'},
            {value: 'gao', label: '高泌乳素血症'},
            {value: 'di', label: '低促性腺激素血症'},
            {value: 'buyu', label: '不孕不育'},
            {value: 'yue', label: '月经失调'},
            {value: 'xian', label: '先天性性分化异常'},
            {value: 'xian', label: '性激素相关肿瘤'}
        ]
    },
    {
        value: 'tumor',
        label: '肿瘤相关检验项目',
        children: [
            {value: 'gan', label: '肝癌'},
            {value: 'pancreas', label: '胰腺癌'},
            {value: 'wei', label: '胃癌'},
            {value: 'dan', label: '胆囊癌'},
            {value: 'jiechang', label: '结直肠癌'},
            {value: 'ru', label: '乳腺癌'},
            {value: 'fei', label: '肺癌'},
            {value: 'nang', label: '卵巢癌'},
            {value: 'nei', label: '子宫内膜癌'},
            {value: 'qianlie', label: '前列腺癌'},
            {value: 'pangguang', label: '膀胱癌'},
            {value: 'shen', label: '肾癌'},
            {value: 'shi', label: '食管癌'},
            {value: 'gongjing', label: '宫颈癌'},
            {value: 'gao', label: '睾丸癌'},
            {value: 'biyan', label: '鼻咽癌'}
        ]
    }
];

export const reagentList = [
    {
        value: 'jiajian',
        label: '甲状腺功能检验项目',
        children: [
            {value: 'TSH', label: '促甲状腺激素（TSH）'},
            {value: 'TT3', label: '总三碘甲状腺原氨酸（TT3）'},
            {value: 'TT4', label: '总甲状腺素（TT4）'},
            {value: 'FT3', label: '游离三碘甲状腺原氨酸（FT3）'},
            {value: 'FT4', label: '游离甲状腺素（FT4）'},
            {value: 'TPOAb', label: '抗甲状腺过氧化物酶抗体（TPOAb）'},
            {value: 'TGAb', label: '抗甲状腺球蛋白抗体（TGAb）'},
            {value: 'TRAb', label: '促甲状腺激素受体抗体（TRAb）'},
            {value: 'Tg', label: '甲状腺球蛋白（Tg）'}
        ]
    },
    {
        value: 'xinji',
        label: '心脏功能检验项目',
        children: [
            {value: 'cTnI', label: '肌钙蛋白I（cTnI）'},
            {value: 'cTnT', label: '肌钙蛋白T（cTnT）'},
            {value: 'Hs-cTnI', label: '高敏肌钙蛋白I（Hs-cTnI）'},
            {value: 'Hs-cTnT', label: '高敏肌钙蛋白T（Hs-cTnT）'},
            {value: 'CK', label: '肌酸激酶（CK）'},
            {value: 'CK-MB', label: '肌酸激酶同工酶（CK-MB）'},
            {value: 'LDH', label: '乳酸脱氢酶（LDH）'},
            {value: 'BNP', label: 'B型利钠肽（BNP）'},
            {value: 'NT-proBNP', label: 'N末端B型利钠肽前体（NT-proBNP）'},
            {value: 'myoglobin/MYO', label: '肌红蛋白（MYO）'},
            {value: 'HCY', label: '同型半胱氨酸（HCY）'}
        ]
    },
    {
        value: 'xinghormone',
        label: '性激素检验项目',
        children: [
            {value: 'FSH', label: '卵泡刺激素（FSH）'},
            {value: 'LH', label: '黄体生成素（LH）'},
            {value: 'PRL', label: '催乳素（PRL）'},
            {value: 'E2', label: '雌二醇（E2）'},
            {value: 'P', label: '孕酮（P）'},
            {value: 'T', label: '睾酮（T）'},
            {value: 'AMH', label: '抗缪勒氏管激素（AMH）'},
            {value: 'HCG', label: '人绒毛膜促性腺激素（HCG）'},
            {value: 'SHBG', label: '性激素结合球蛋白（SHBG）'},
            {value: 'PAPP-A', label: '妊娠相关的血浆蛋白A（PAPP-A）'}
        ]
    },
    {
        value: 'tumor',
        label: '肿瘤相关检验项目',
        children: [
            {value: 'CEA', label: '癌胚抗原（CEA）'},
            {value: 'CA125', label: '糖类抗原 125（CA125）'},
            {value: 'CA19-9', label: '糖类抗原 19-9（CA19-9）'},
            {value: 'CA15-3', label: '糖类抗原 15-3（CA15-3）'},
            {value: 'SCC', label: '鳞状上皮细胞癌抗原（SCC）'},
            {value: 'NSE', label: '神经元特异性烯醇化酶（NSE）'},
            {value: 'Pro-GRP', label: '胃泌素前体释放肽片段（Pro-GRP）'},
            {value: 'CYFRA21-1', label: '细胞角蛋白 19 的片段（CYFRA21-1）'},
            {value: 'PSA', label: '前列腺特异性抗原（PSA）'},
            {value: 'fPSA', label: '游离前列腺特异性抗原（fPSA）'},
            {value: 'p2PSA', label: '前列腺特异性抗原同源异构体（p2PSA）'},
            {value: 'AFP', label: '甲胎蛋白（AFP）'},
            {value: 'CA50', label: '糖类抗原 50（CA50）'},
            {value: 'CA72-4', label: '糖类抗原 72-4（CA72-4）'},
            {value: 'CA242', label: '糖类抗原 242（CA242）'},
            {value: 'PGI', label: '胃蛋白酶原I（PGI）'},
            {value: 'PGII', label: '胃蛋白酶原II（PGII）'},
            {value: 'G-17', label: '胃泌素17（G-17）'}
        ]
    }
];
